let number = 0;
export const generateId = (label: string): string =>
    label.replace(/\s/g, '_') /* replace all spaces with underscores */ + '_' + ++number;
